var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.72 17.33C20.72 17.69 20.64 18.06 20.47 18.42C20.3 18.78 20.08 19.12 19.79 19.44C19.3 19.98 18.76 20.37 18.15 20.62C17.55 20.87 16.9 21 16.2 21C15.18 21 14.09 20.76 12.94 20.27C11.79 19.78 10.64 19.12 9.5 18.29C8.35 17.45 7.26 16.52 6.22 15.49C5.19 14.45 4.26 13.36 3.43 12.22C2.61 11.08 1.95 9.94 1.47 8.81C0.99 7.67 0.75 6.58 0.75 5.54C0.75 4.86 0.87 4.21 1.11 3.61C1.35 3 1.73 2.44 2.26 1.94C2.9 1.31 3.6 1 4.34 1C4.62 1 4.9 1.06 5.15 1.18C5.41 1.3 5.64 1.48 5.82 1.74L8.14 5.01C8.32 5.26 8.45 5.49 8.54 5.71C8.63 5.92 8.68 6.13 8.68 6.32C8.68 6.56 8.61 6.8 8.47 7.03C8.34 7.26 8.15 7.5 7.91 7.74L7.15 8.53C7.04 8.64 6.99 8.77 6.99 8.93C6.99 9.01 7 9.08 7.02 9.16C7.05 9.24 7.08 9.3 7.1 9.36C7.28 9.69 7.59 10.12 8.03 10.64C8.48 11.16 8.96 11.69 9.48 12.22C10.02 12.75 10.54 13.24 11.07 13.69C11.59 14.13 12.02 14.43 12.36 14.61C12.41 14.63 12.47 14.66 12.54 14.69C12.62 14.72 12.7 14.73 12.79 14.73C12.96 14.73 13.09 14.67 13.2 14.56L13.96 13.81C14.21 13.56 14.45 13.37 14.68 13.25C14.91 13.11 15.14 13.04 15.39 13.04C15.58 13.04 15.78 13.08 16 13.17C16.22 13.26 16.45 13.39 16.7 13.56L20.01 15.91C20.27 16.09 20.45 16.3 20.56 16.55C20.66 16.8 20.72 17.05 20.72 17.33Z",
    fill: "#C9CACD",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone_icon.fba679e3242bb7b7a787b43dc16a86be.svg";
export { ForwardRef as ReactComponent };